import store from '@/store'
class WebSocketUtils {
    constructor() {
        this.url = null; // ws地址 或者 wss
        this.data = null;
        this.isOpenSocket = false; // 避免重复连接
        this.timeout = 15; // 隔多久执行检测 单位秒（s）
        this.heartbeatInterval = null; // 检测服务器端是否还存活
        this.reconnectTimeOut = null; // 重连之后隔多久才再次重连
        this.noMessageTimeout = 60; // 设置未收到消息的超时时间（单位秒）
        this.messageTimer = null; // 用于监测消息接收超时
        this.callback = null;//消息回调
    }

    // 创建websocket连接
    connectSocketInit(url, callback) {
        this.callback = callback
        if (!this.socketTask || this.socketTask.readyState === WebSocket.CLOSED) {
            this.url = url;
            this.socketTask = new WebSocket(url);
            this.socketTask.onopen = (event) => {
                console.log("==============WebSocket打开连接=============", event);
                clearTimeout(this.reconnectTimeOut);
                clearInterval(this.heartbeatInterval);
                this.isOpenSocket = true;
                // let msg = JSON.stringify({
                //     "message": "PING",
                //     "srvVer": 1,
                //     "srvFeature": "0",
                //     "srvTs": new Date().getTime(),
                // });
                // this.socketTask.send(msg);
                this.startPingPong();
                let params = {
                    srvTs: new Date().getTime(), // 时间戳，为确保每次推送都能被监听到
                    data: "WebSocket打开连接",
                }
                store.commit('setSocketOpen', params)
            };

            // 连接正常 接收消息中
            this.socketTask.onmessage = (event) => {
                // console.log(event, '===========onmessage==============')
                if (this.messageTimer) {
                    clearTimeout(this.messageTimer);
                    this.messageTimer = null
                }
                // 重置消息接收计时器
                this.resetMessageTimer();
                try {
                    if (event.data && event.data != 'null') {
                        const jsonData = JSON.parse(event.data);
                        // console.log(jsonData);
                        // 将获的取消息导出外部
                        // console.log(event, '===============exportMessage============');
                        if (!jsonData.message) {
                            return;
                        }
                        if (jsonData.message == "PONG") {
                            // 心跳恢复信息排除导出
                            return;
                        }
                        try {
                            return callback(jsonData);
                        } catch (err) {
                            console.error('exportMessage-err', err);
                            return callback(err);
                        }
                    }
                } catch (err) {
                    console.error('onmessage-err', err);
                }


            };

            // socket关闭了会执行此处
            this.socketTask.onclose = (event) => {
                console.log("========onclose============", event);
                this.isOpenSocket = false;
                this.socketTask = null;
                this.stopPingPong();
                if (event.code !== 4000) {
                    setTimeout(() => {
                        console.log('=========关闭重连reconnect===========');
                        this.reconnect();
                    }, 3000);
                }
            };

            this.socketTask.onerror = (error) => {
                console.log('============onerror============', error);
            };
        } else {
            console.log('Socket exists, no need to create it, 链接状态：', this.socketTask.readyState === WebSocket.OPEN);
        }
    }

    // 发送消息
    send(message) {
        // 连接正常打开时，才能正常成功发送消息
        if (this.socketTask && this.socketTask.readyState === WebSocket.OPEN) {
            this.socketTask.send(message);
        }
    }

    // 重新连接
    reconnect() {
        const _this = this;

        if (!_this.url) {
            return;
        }
        // 停止发送心跳
        clearInterval(_this.heartbeatInterval);
        // 如果不是人为关闭的话，进行重连
        if (!_this.isOpenSocket) {
            _this.reconnectTimeOut = setTimeout(() => {
                _this.connectSocketInit(_this.url, _this.callback);
            }, 3000);
        }
    }

    // 关闭 WebSocket 连接
    closeSocket(code = 4000, reason = '关闭') {
        const _this = this;
        _this.socketTask.close(code, reason);
        _this.data = null;
        _this.url = null;
        _this.isOpenSocket = false;
        clearTimeout(_this.reconnectTimeOut);
        clearInterval(_this.heartbeatInterval);
        clearTimeout(_this.messageTimer); // 清理消息计时器
        console.log('===============关闭 WebSocket 成功===================');
    }

    // 开启心跳检测
    startPingPong() {   
        const _this = this;

        if (_this.heartbeatInterval) {
            clearInterval(_this.heartbeatInterval);
        }

        _this.heartbeatInterval = setInterval(() => {
            _this.data = JSON.stringify({
                "message": "PING",
                "srvVer": 1,
                "srvFeature": "0",
                "srvTs": new Date().getTime(),
            });
            _this.send(_this.data);
        }, _this.timeout * 1000);

        // 启动消息接收超时计时器
        this.resetMessageTimer();
    }

    stopPingPong() {
        // 停止Ping-Pong定时器
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
        clearTimeout(this.messageTimer); // 停止消息计时器
    }

    // 重置消息接收计时器
    resetMessageTimer() {
        clearTimeout(this.messageTimer);
        this.messageTimer = setTimeout(() => {
            console.log('===========长时间未收到消息，开始重连...=======');
            this.reconnect();
        }, this.noMessageTimeout * 1000); // 超时设置
    }

    
}

const websocketUtils = new WebSocketUtils();

export default websocketUtils;
